<template>
<v-dialog v-model="show" max-width="600" scrollable>
  <template v-slot:activator="{on}">
    <slot name="activator" :on="on">
      <v-btn v-on="on" tile outlined small>Discounts</v-btn>
    </slot>
  </template>
  <v-card :loading="loading" :disabled="loading">
    <CardTitle title="Customer Discounts">
      <template v-slot:actions>
        <v-btn @click="loadDiscountDataSet" icon><v-icon>refresh</v-icon></v-btn>
        <v-btn @click="show = false" icon><v-icon>close</v-icon></v-btn>
      </template>
    </CardTitle>
    <v-card-text>
      <v-simple-table>
        <thead>
          <tr>
            <th>Customer Name</th>
            <th>Discount</th>
            <th>Edit</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(discount, index) in customersWithDiscounts"  :key="discount.id">
            <td>{{discount.customer.primary_name.name}}</td>
            <td>{{ discount.discount }}%</td>
            <td><v-edit-dialog></v-edit-dialog></td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-card-text>
  </v-card>
</v-dialog>
</template>

<script>
export default {
    name: "GlobalDiscounts",
    components: {},
    data: () => ({
      show: false,
      loading: false,
    }),
    computed: {
      customersWithDiscounts() {
        return this.$store.$db().model('billings').query().where(item => item.discount !== 0 || item.discount !== '0').with('customer').orderBy('discount', 'desc').get();
      }
    },
    watch:{
      show(v){
        if(v){
          this.loadDiscountDataSet()
        }
      }
    },
    mounted(){
      this.loadDiscountDataSet()
    },
    methods: {
      async loadDiscountDataSet(){
        if(this.loading) return;
        this.loading = true;
        await this.$store.$db().model('billings').api().fetch({},"", (res) => {
          return res.data.filter(item => item.discount > 0);
        })
        this.loading = false;
      }
    }
}
</script>

<style scoped>

</style>